import { TypedTypePolicies } from '@storefront/data-commerce';

export const magentoTypePolicie: TypedTypePolicies = {
  BundleItem: { keyFields: ['uid'] },
  BundleItemOption: { keyFields: ['uid'] },
  BundleProduct: { keyFields: ['uid'] },
  Cart: { keyFields: ['id'] },
  CartItem: { keyFields: ['uid'] },
};
